import React from 'react';
import {
  Popover as PopoverPrimitive,
  PopoverContent as PopoverContentPrimitive,
  PopoverTrigger as PopoverTriggerPrimitive,
} from '@/components/ui/popover';
import { cn } from '@/lib/utils';

export interface PopoverProps {
  children: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const Popover = ({ children, ...props }: PopoverProps) => (
  <PopoverPrimitive {...props}>{children}</PopoverPrimitive>
);
Popover.displayName = 'Popover';

export interface PopoverTriggerProps {
  children: React.ReactNode;
  asChild?: boolean;
  className?: string;
}

export const PopoverTrigger = React.forwardRef<HTMLButtonElement, PopoverTriggerProps>(
  ({ children, className, asChild, ...props }, ref) => (
    <PopoverTriggerPrimitive asChild={asChild} ref={ref} className={cn(className)} {...props}>
      {children}
    </PopoverTriggerPrimitive>
  )
);
PopoverTrigger.displayName = 'PopoverTrigger';

export interface PopoverContentProps {
  children: React.ReactNode;
  className?: string;
  align?: 'start' | 'end' | 'center';
}

export const PopoverContent = React.forwardRef<HTMLDivElement, PopoverContentProps>(
  ({ children, className, align, ...props }, ref) => (
    <PopoverContentPrimitive ref={ref} align={align} className={cn(className)} {...props}>
      {children}
    </PopoverContentPrimitive>
  )
);
PopoverContent.displayName = 'PopoverContent';
